/**
 * Environment variables utility
 * Provides easy access to environment variables with fallbacks
 */

const getEnvVar = (key, defaultValue = '') => {
  // Try to get from import.meta.env (Vite's way)
  if (import.meta.env && import.meta.env[key]) {
    return import.meta.env[key]
  }
  
  // Return default value
  return defaultValue
}

export const env = {
  // API Configuration
  API_BASE_URL: getEnvVar('VITE_API_BASE_URL', ''),
  
  // Google OAuth
  GOOGLE_CLIENT_ID: getEnvVar('VITE_GOOGLE_CLIENT_ID', ''),
  
  // App Configuration
  MODE: getEnvVar('MODE', 'development'),
  NODE_ENV: getEnvVar('NODE_ENV', 'development'),
  
  // Helper methods
  isDevelopment: () => getEnvVar('MODE', 'development') === 'development',
  isProduction: () => getEnvVar('MODE', 'development') === 'production',
  
  // Get all environment variables
  getAll: () => ({
    API_BASE_URL: getEnvVar('VITE_API_BASE_URL', ''),
    GOOGLE_CLIENT_ID: getEnvVar('VITE_GOOGLE_CLIENT_ID', ''),
    MODE: getEnvVar('MODE', 'development'),
    NODE_ENV: getEnvVar('NODE_ENV', 'development'),
  })
}

export default env
